<template>
<v-container :style="styleProps">
  <v-card class="mt-8" flat>
    <v-card-title class="justify-center" style="word-break: break-word">{{
      work_label
    }}</v-card-title>
  </v-card>
</v-container>
</template>
<script setup>
  import useVuexPathify from "@/../../library/compFunctions/useVuexPathify.js";
  import phraseProc from "@/../../library/helper/phrase.js";
  import { computed, getCurrentInstance } from "vue";

  // Define the properties
  const props = defineProps({ args: { type: String, required: true } ,formStyle: { type: String, required: false }});

  // Get the Store information
  const vm = getCurrentInstance();
  const { get } = useVuexPathify(vm.proxy);
  const userlang = get("misc/language").value;
  const phrases = get("misc/phraseMap").value;

  const work_label = computed(() => {
    return phraseProc.mapPhrase(props.args, phrases, userlang);
  });

  // Define the style for this panel
  const styleProps = computed(() => {
    if (props.formStyle) return props.formStyle;
    return "width:800px; vertical-align:top; height:100vh";
  });
</script>